module.exports = __webpack_public_path__ + "assets/liferay.083bab5c.svg";